export function getFilled(value, deep) {
  if (!value) return;
  value = JSON.parse(JSON.stringify(value));

  if (Array.isArray(value)) return checkArray(value, deep);
  if (value instanceof Object) return checkObject(value, deep);
}

function checkArray(arr, deep) {
  return arr.filter(item => {
    if (Array.isArray(item)) {
      if (deep) item = checkArray(arr, deep);
      if (item.length) return true;
    } else if (item.prototype.constructor === Object) {
      if (deep) item = checkObject(item, deep);
      if (JSON.stringify(item) !== '{}') return true;
    } else if (item || item === 0) return true;

    return false;
  });
}

function checkObject(obj, deep) {
  const newObject = {};
  for (const key in obj) {
    if (obj[key] || obj[key] === 0) {
      if (Array.isArray(obj[key])) {
        if (obj[key].length) {
          if (deep) {
            const arr = checkArray(obj[key], deep);
            if (arr.length) newObject[key] = arr;
          } else newObject[key] = obj[key];
        }
      } else if ((obj[key] instanceof Object)) {
        if (JSON.stringify(obj) !== '{}') {
          if (deep) {
            const obj = checkObject(obj[key], deep);
            if (JSON.stringify(obj) !== '{}') newObject[key] = obj;
          } else newObject[key] = obj[key];
        }
      } else newObject[key] = obj[key];
    }
  }
  return newObject;
}
